import axios from "axios";
import { toast } from "react-toastify";

/**
 * Setup axios interceptor to handle token expiration and 401 errors
 * Automatically redirects to login on 401 response
 */
export const setupAxiosInterceptor = (navigate) => {
  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userDetail");
        
        toast.error("Session expired. Please login again.");
        navigate("/auth-login", { replace: true });
      } else if (error.response?.status === 403) {
        // Forbidden - insufficient permissions
        toast.error("You don't have permission to access this resource.");
      }
      return Promise.reject(error);
    }
  );
};
